import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaSearch, FaRobot, FaFileAlt, FaBrain } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './AIRPASection.css';

const AIRPASection = () => {
  const { t } = useTranslation();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const features = [
    {
      icon: '/assets/images/Heart-Rate-Search Streamline Core-Neon.svg',
      title: t('aiRpa.features.mining.title'),
      description: t('aiRpa.features.mining.description')
    },
    {
      icon: '/assets/images/Cyborg-2 Streamline Core-Neon.svg',
      title: t('aiRpa.features.autopilot.title'),
      description: t('aiRpa.features.autopilot.description')
    },
    {
      icon: '/assets/images/Multiple-File-2 Streamline Core-Neon.svg',
      title: t('aiRpa.features.document.title'),
      description: t('aiRpa.features.document.description')
    }
  ];

  return (
    <section className="ai-rpa" ref={ref}>
      <div className="container">
        <motion.div
          className="ai-rpa-content"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <div className="ai-eyebrow">{t('aiRpa.eyebrow')}</div>
          <h2>{t('aiRpa.title')}</h2>
          <p>{t('aiRpa.subtitle')}</p>

          <div className="ai-features">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                className="ai-feature"
                initial={{ opacity: 0, y: 30 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.6, delay: 0.2 + index * 0.1 }}
              >
                <img src={feature.icon} alt="" className="ai-feature-icon" />
                <h4>{feature.title}</h4>
                <p>{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AIRPASection;